import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { HotToastService } from '@ngneat/hot-toast';
import { Subscription } from 'rxjs';
import { ChangeUserPasswordWhenSignedInRequest } from 'src/app/core/dtos/dto';
import { HttpErrorResponseMessages } from 'src/app/core/dtos/http-error-response-messages';
import { AccountService } from 'src/app/core/services/account.service';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { PasswordStrengthMeterComponent } from 'src/app/shared/components/password-strength-meter/password-strength-meter.component';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
  userForm: FormGroup;
  passwordPattern = '(?=.*\\d)(?=.*[a-zA-Z]).{8,128}';

  get f() { return this.userForm.controls; }
  authSubscription: Subscription;

  constructor(
    private formBuilder: FormBuilder,
    private accountService: AccountService,
    private toastService: HotToastService,
    private router: Router,
    private authenticationService: AuthenticationService
  ) { }

  ngOnInit(): void {
    this.userForm = this.formBuilder.group({
      oldPassword: ['', Validators.required],
      newPassword: ['', [Validators.required, Validators.pattern(this.passwordPattern)]],
      newPasswordConfirm: ['', Validators.required],
    });
  }
  onSubmit() {
    if (this.userForm.controls.newPassword.value !== this.userForm.controls.newPasswordConfirm.value) {
      this.toastService.warning('Please enter matching passwords.');
      return;
    }
    const newPasswordRequest: ChangeUserPasswordWhenSignedInRequest = {
      oldPassword: this.userForm.controls.oldPassword.value,
      newPassword: this.userForm.controls.newPassword.value
    };
    this.accountService.changePasswordSignedIn(newPasswordRequest).subscribe(
      () => {
        this.toastService.success("Password Successfully Changed");
        //Get New Auth based on reset password
        const email = this.authenticationService.getEmail();
        this.authSubscription = this.accountService.getAuthToken(email, this.userForm.controls.newPassword.value, "")
          .subscribe(
            result => {
              this.authenticationService.setAuthentication(result, email);
              this.router.navigate(['my-account']);
            },
            (error: HttpErrorResponse) => {
              if (error.error.error === "invalid_grant" && error.error.error_description) {
                this.toastService.warning(error.error.error_description);
              }
              else if (error.status === 400 && error.error.error_description) {
                this.toastService.warning(error.error.error_description);
              }
              else {
                this.toastService.warning("Failed to login because of unknown problem. Please contact Paragon.");
              }
            });
      },
      (error: HttpErrorResponse) => {
        if (error.status === 400) {
          const errorMessage = error.error as HttpErrorResponseMessages;
          errorMessage.reasons.forEach(reasons => {
            this.toastService.warning(reasons.errorMessage);
          });
        }
      });
  }

}
